export const COMPOSITION_THREAD_ID = 'COMPOSITION_THREAD_ID';
export const COMPOSITION_REPLY_ID = 'COMPOSITION_REPLY_ID';